import { Injectable } from '@angular/core'

import { StyleLoaderService } from './../core/style-loader/style-loader.service'

export interface MobileBreadcrumbStyle {
  'margin-top': string
}

export interface MobileTreeStyle {
  'margin-top': string
  'max-height': string
}

interface MobileStyles {
  breadcrumb: MobileBreadcrumbStyle
  tree: MobileTreeStyle
}

@Injectable({providedIn: 'root'})
export class LeftNavMobileStyleService {

  constructor(private styleLoaderService: StyleLoaderService) {
    // noop
  }

  public getMobileStyles(navId: string, hasAnItemExpanded: boolean, hasAnItemCollapsing: boolean): MobileStyles {

    const contextHeight = this.getContextHeight(navId)
    const footerHeight = this.getFooterLogoHeight(navId)
    const seBarOffset = this.getSeBarOffset()
    const treeOffset = contextHeight + footerHeight + seBarOffset
    const treeMaxHeight = (hasAnItemExpanded || hasAnItemCollapsing) ? 'none' : `calc(100% - ${treeOffset}px)`
    const breadcrumbStyle = {'margin-top': `${contextHeight}px`}
    const treeStyle = {'margin-top': `${contextHeight}px`, 'max-height': treeMaxHeight}

    return { breadcrumb: breadcrumbStyle, tree: treeStyle }

  }

  public getContextHeight(navId: string): number {
    const contextElement = document.getElementById(`${navId}-left-nav-context`)
    return (contextElement) ? contextElement.clientHeight : 0
  }

  public getFooterLogoHeight(navId: string): number {
    const contextElement = document.getElementById(`${navId}-left-nav-footer-logo`)
    return (contextElement) ? contextElement.clientHeight : 0
  }

  public getSeBarOffset(): number {
    const variable = this.styleLoaderService.getVariable('se-left-nav-mobile-se-bar-offset')
    return (variable) ? variable.value : 0
  }

}
